import React from "react";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { aboutPage, seo } from "../data/siteData";

export default function About() {
  useSeo(seo["/about-us"].title, seo["/about-us"].description);
  useReveal();
  return (
    <>
      <PageHero image={aboutPage.hero} title={aboutPage.h1} />
      <section className="bg-white py-16">
        <div className="mr-container mr-body reveal">
          {aboutPage.paragraphs.map((p) => (
            <p key={p.slice(0, 30)} className="text-[16.5px]">
              {p}
            </p>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
